<template>
  <div class="clearfix no-margin clip-toolbar-body">
    <div class="maincontent">
      <!-- Start: Fist line of pop-up that shows the search bar and the close button -->
      <section class="clip-toolbar-menu">
        <div class="container-custom">
          <div class="col-md-3 col-sm-3 col-xs-12 text-uppercase">
            <a
              href=""
              data-target="#newClip"
              data-toggle="modal"
              data-keyboard="true"
              class="clip-toolbar-menu btn-lg btn-cancel create-clip"
              :data-section="sectionKey"
              :data-clip_type_id="bookSections"
              >CREATE {{ trans("clip.singular") }}
              <i class="fa fa-plus"></i>
            </a>
          </div>
          <div class="col-md-9 col-sm-9 col-xs-12 no-padding toolbar-option">
            <ul class="menubar no-padding" id="toolbar-tabs" role="tablist">
              <li
                role="presentation"
                class=""
                :class="{ active: isActive('myclip') }"
              >
                <a
                  href="#my-clips"
                  id="my-clips-tab"
                  role="tab"
                  class="colorWhite text-capitalize"
                  @click.prevent="myClips"
                  >My {{ trans("clip.multiple") }}</a
                >
              </li>
              <li
                role="presentation"
                :class="{ active: isActive('bookmarkedclip') }"
              >
                <a
                  href="#bookmarked-clips"
                  id="bookmarked-clips-tab"
                  role="tab"
                  class="colorWhite text-capitalize"
                  @click.prevent="bookmarkedClips"
                  >Bookmarked {{ trans("clip.multiple") }}</a
                >
              </li>
              <li
                role="presentation"
                class="remove-border"
                :class="{ active: isActive('communityclip') }"
              >
                <a
                  href="#community-clips"
                  id="community-clips-tab"
                  role="tab"
                  class="colorWhite text-capitalize"
                  @click.prevent="communityClips"
                  >Community {{ trans("clip.multiple") }}</a
                >
              </li>
              <li role="presentation" class="cliptoolbar-search">
                <div
                  class="
                    input-group
                    cliptoolbar-search-container
                    add-clip-search
                  "
                >
                  <span class="add-clip-input input-group-addon"
                    ><i class="fa fa-search"></i
                  ></span>
                  <input
                    type="text"
                    name="search"
                    class="
                      add-clip-search-box
                      form-control
                      cliptoolbar-searchbox
                    "
                    @keyup.enter="searchClips"
                    v-model="searchWord"
                  />
                </div>
              </li>
            </ul>
            <ul class="toolbar" style="float: right">
              <li>
                <a href="#" class="expand-arrow colorWhite open-window"
                  ><i class="fa fa-arrows-alt"></i
                ></a>
              </li>
              <li>
                <a
                  href="#"
                  class="colorWhite close-window"
                  @click="$emit('close')"
                  ><i class="fa fa-times"></i
                ></a>
              </li>
            </ul>
          </div>
          <div class="clearfix"></div>
        </div>
      </section>
      <!-- End: Fist line of pop-up that shows the search bar and the close button -->

      <!-- Start Second line of pupup  -->
      <div class="expand-section">
        <section class="container-custom clip-toolbar-content clearfix">
          <div class="col-xs-12 main-row">
            <div class="toolbar-title">
              <ul>
                <li class="hg-title">
                  <a :href="editUrl" class="text-capitalize">{{
                    bookDetails.title
                  }}</a>
                </li>
                <li>
                  <a href="" class="text-capitalize">{{ section }}</a>
                </li>
              </ul>
            </div>
            <div class="toolbar-action">
              <button
                type="submit"
                class="btn btn-lg btn-selectedclip text-uppercase"
                @click.prevent="submit"
                :disabled="selectedClips.length < 1"
              >
                ADD <span class="selected-keyword">SELECTED </span
                >{{ trans("clip.multiple")
                }}<span>({{ selectedClips.length }})</span>
                <i class="fa fa-plus-circle"></i>
              </button>
              <a
                href="#"
                class="btn-lg btn-cancel"
                @click="unSelectAll"
                :disabled="selectedClips.length < 1"
                >DELETE ALL <i class="fa fa-times-circle"></i
              ></a>
            </div>
          </div>
        </section>
        <!-- End Second line of pupup  -->

        <!-- Start: Main body part that shows the clips for insert -->
        <section>
          <div class="toolbar-clips tab-content clearfix">
            <div class="container-custom">
              <clip-slider
                @getValueToSelectTab="setActiveTab"
                @calculateSelectedClips="setSelectedClips"
                ref="clipSlider"
                :exist-clips="sectionClips"
                :section-key="sectionKey"
              ></clip-slider>
            </div>
          </div>
        </section>
        <div class="ajax-loader" :class="activeLoader">
          <div>
            <i class="fa fa-spinner fa-pulse fa-5x fa-fw ajax-overlay"></i>
          </div>
        </div>
      </div>
      <!-- End: Main body part that shows the clips for insert -->
    </div>
  </div>
</template>

<script>
import ClipSlider from "../components/ClipSlider.vue";

export default {
  props: [
    "bookId",
    "bookDetails",
    "existClips",
    "sectionKey",
    "section",
    "loader",
    "bookSections",
  ],
  components: { ClipSlider },
  data() {
    return {
      selectedClipsCount: 0,
      selectedClips: [],
      activeItem: "",
      searchWord: "",
      existingClips: this.existClips,
      activeLoader: this.loader,
    };
  },
  computed: {
    editUrl: function () {
      return this.route("user.book.edit", { slug: this.bookDetails.slug });
      // return route('user.book.edit',this.bookDetails.slug).url();
    },
    sectionClips: function () {
      var vm = this;
      let list = this.$store.state.savedClipList;
      let saved_list = this.$store.getters.getCurrentSectionClips(
        vm.sectionKey
      );

      // Convert object to array because object give an issue in the slider components
      var array = $.map(saved_list, function (value, index) {
        return [value];
      });
      return array;
    },
  },
  methods: {
    slug(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "");
    },
    setActiveTab(value) {
      this.activeItem = value;
      this.activeLoader = "hide";
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function (menuItem) {
      this.activeItem = menuItem; // no need for Vue.set()
    },
    setSelectedClips(selectedClips) {
      this.selectedClips = selectedClips;
      this.selectedClipsCount = selectedClips.length;
    },
    unSelectAll() {
      // We emit the event on the child component
      this.$refs.clipSlider.unSelectAll();
    },
    submit() {
      let section_id = this.sectionKey;
      let section_name = this.slug(this.section);
      var data = {};
      data["" + section_id] = this.selectedClips;
      this.$store.commit("isLoading", true);
      axios
        .post(this.route("user.book.updateClipList", { id: this.bookId }), {
          clip_list: data,
          from_clip_slider: true,
        })
        .then(({ data }) => {
          this.$emit("completed", { result: data, section_id: section_id });
          if (location.hash) {
            var currentUrl = window.location.pathname + "#" + section_name;
            window.location = currentUrl;
          }
        });
    },
    bookmarkedClips() {
      var app = this;
      this.activeLoader = "show";

      this.$refs.clipSlider.bookmarkedClip().then((res) => {
        app.setActive("bookmarkedclip");
        app.activeLoader = "hide";
      });
    },
    myClips() {
      var app = this;
      this.activeLoader = "show";

      this.$refs.clipSlider.myClip().then((res) => {
        app.setActive("myclip");
        app.activeLoader = "hide";
      });
    },
    communityClips() {
      var app = this;
      this.activeLoader = "show";

      this.$refs.clipSlider.communityClip().then((res) => {
        app.setActive("communityclip");
        app.activeLoader = "hide";
      });
    },
    searchClips() {
      this.$refs.clipSlider.searchClip(this.searchWord, this.activeItem);
    },
  },
};
</script>

<style>
.cliptoolbar-searchbox:focus {
  box-shadow: none !important;
}
.btn-cancel:focus {
  color: white !important;
  text-decoration: none !important;
}
</style>